import commonTranslations from "../../../common/translations";
import sweetAlerts from "./sweetAlerts";
import notificationService from "./notificationService";
import templates from "./templates";
import errors from "./errors";
import tinyMCE from "./tinyMCE";
import components from "./components";
import forms from "./forms";
import factories from "./factories";

export default {
  ...commonTranslations,
  ...sweetAlerts,
  ...notificationService,
  ...templates,
  ...errors,
  ...factories,
  ...forms,
  ...components,
  ...tinyMCE,
};
